var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"videoWrap",staticClass:"video-wrap"},[_c('div',{attrs:{"id":"interactiveVideo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }